import { GaugeChartProps } from '@silverfort/sf-components';
import { Insights } from '../../../types/Insights';
import { useMemo } from 'react';

const MINIMUM_VALUE = 0.1;

const usePairedUsers = (insights: Insights): GaugeChartProps => {
    return useMemo(() => {
        const totalProtectedPer = insights.activePairedUsers / (insights.totalProtectedUsers || 1);
        const value = totalProtectedPer > 0 ? Math.max(totalProtectedPer, MINIMUM_VALUE) : 0;
        const isLowerThen = value === MINIMUM_VALUE;

        return {
            value: value,
            label: 'Active users',
            startColor: '#ff4d88',
            endColor: '#ffd7e5',
            tooltipContent: `Active users are users that have performed an authentication in the last 6 months.`,
            lowerThen: isLowerThen
        };
    }, [insights]);
};

export default usePairedUsers;
